<template>
  <div class="target_wrap">
    <div class="target_people">
      <div>针对 <span>{{taskChildData.taskName || '-'}}</span> 中已发券的 <span>{{detailForm.actualCouponNum || '-'}}</span>人，对比分析其<span>发券前后</span>的行为数据；统计时间：{{taskChildData.startTimeFormat || '-'}}至{{taskChildData.endTimeFormat || '-'}}<span style="color: #808080" v-if="taskChildData.status === 4">(持续更新中)</span></div>
      <div>
        <!-- <el-button size="mini" :disabled="ordinateHis.length === 0">下载数据</el-button> -->
        <download-button :otherDisab="isData" :downloadApi="effectDataExport" :queryParams="{ ...downloadParams }" style="margin-right: 10px;" :text="'下载数据'"></download-button>
        <el-button size="mini" @click="toImg('business', '目标用户群营销效果对比分析', taskChildData.taskName)" :disabled="ordinateHis.length === 0">下载图片</el-button>
      </div>
    </div>
    <div class="target_card">
      <div class="card" v-for="(item, index) in list" :key="index">
        <div>
          <span>{{item.name}}</span>
          <el-popover
              placement="top"
              trigger="hover">
              <div class="pop-container">
                <div>{{item.explain}}</div>
              </div>
              <span class="que" slot="reference">?</span>
            </el-popover>
        </div>
        <div><span>{{item.value | isNullOr0}}</span><span>{{item.unit}}</span></div>
      </div>
    </div>
    <div class="target_sele">
      <span>显示设置: </span>
      <el-select v-model="value" placeholder="请选择" @change="handleChangeHis">
        <el-option
          v-for="(item, index) in list"
          :key="index"
          :label="item.name"
          :value="item.name">
        </el-option>
      </el-select>
    </div>
    <div class="target_user_pic" v-if="ordinateHis.length > 0">
      <targetUserPic :id="'business'" :data="ordinateHis" :xData="xData"/>
    </div>
    <noDataPic v-else/>
  </div>
</template>
<script>
import { cloneObj } from '@/utils/utils'
import { effectDataExport } from '@/api/vipMarket/userData'
import mixinDown from './mixin'
import { mapGetters } from 'vuex'
import noDataPic from './noDataPic'
import targetUserPic from './targetUserPic'
export default {
  mixins: [mixinDown],
  props: {
    targetUser: {
      type: Object
    },
    // 选择完营销任务后附带的一堆字段
    taskChildData: {
      type: Object
    },
    isChangeTask: {
      type: Array
    }
  },
  data () {
    return {
      list:[],
      value: '加油金额',
      ordinateHis: [], // 需要渲染的数据
      xData: [], // 横坐标
      detailForm: {}, // 其他字段展示
      oilCntList: [], // 加油次数展示数据
      userNumList: [], // 加油人数展示数据
      amountList: [], // 加油金额展示数据
      litreList: [], // 加油升数展示数据
      priceList: [], // 客单价数展示数据
      downloadParams: {}, // 下载的参数
      effectDataExport
    }
  },
  watch: {
    targetUser: {
      handler (value) {
        const { actualCouponNum, taskStartTime, taskEndTime, oilCnt, oilNum, oilAmount, oilLitre, avgCustPrice, oilCntList, userNumList, amountList, litreList, priceList, dateList } = value
        this.detailForm = { actualCouponNum, taskStartTime, taskEndTime }
        this.list = [
          { value: oilCnt, name: '加油次数', unit: '次', explain: '用券订单加油笔数' },
          { value: oilNum, name: '加油人数', unit: '人', explain: '用券订单加油人数' },
          { value: oilAmount, name: '加油金额', unit: '元', explain: '用券订单加油金额（原价）' },
          { value: oilLitre, name: '加油升数', unit: '升', explain: '用券订单加油升数' },
          { value: avgCustPrice, name: '客单价', unit: '元', explain: '用券订单加油金额/用券订单加油笔数' }
        ]
        this.xData = dateList // 横坐标
        this.oilCntList = oilCntList
        this.userNumList = userNumList
        this.amountList = amountList
        this.litreList = litreList
        this.priceList = priceList
        // 默认展示加油金额的
        let hisData = []
        hisData = cloneObj(this.amountList || [])
        hisData.length > 0 && hisData.forEach(item => {
        item.data = item.dataList || []
        delete item.dataList
        item.type = 'bar'
        item.stack = 'Ad'
        if (item.name === '客单价') {
          delete item.stack
        }
        item.barWidth = 40
      })
      this.value = '加油金额'
      this.ordinateHis = cloneObj(hisData)
      },
      immediate: true
    },
    // 任务附带字段
    taskChildData: {
      handler (val) {
        this.downloadParams = { gasId: this.userInfo.gasId, taskId: val.id }
      }
    },
    // 任务改变，所有子页面的下拉框清空
    isChangeTask: {
      handler (val) {
        if (val) {
          this.ordinateHis = [] // 渲染清空
          this.value = '' // 选择框清空
        }
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    isData () {
      return !this.list[0].value && this.list[0].value !== 0
    }
  },
  components: {
    targetUserPic,
    noDataPic
  },
  methods: { 
    handleChangeHis (val) {
      let hisData = []
      this.ordinateHis = []
      switch (val) {
        case '加油次数':
          hisData = cloneObj(this.oilCntList)
          break
        case '加油人数':
          hisData = cloneObj(this.userNumList)
          break
        case '加油金额':
          hisData = cloneObj(this.amountList)
          break
        case '加油升数':
          hisData = cloneObj(this.litreList)
          break
        case '客单价':
          hisData = cloneObj(this.priceList)
          break
      }
      hisData.forEach(item => {
        item.data = item.dataList || []
        delete item.dataList
        item.type = 'bar'
        item.stack = 'Ad'
        if (item.name === '客单价') {
          delete item.stack
        }
        item.barWidth = 40
      })
      this.ordinateHis = cloneObj(hisData)
    }
  }
}
</script>
<style scoped lang="less">
.target_wrap{
  padding: 0 20px 0 20px;
}
.target_people{
  width: 100%;
  height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  >div:nth-child(1){
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    >span{
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #3377FF;
    }
  }
  .target_btn{
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid #C0C4CC;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
  }
}
.target_card{
  width: 100%;
  margin-top: 10px;
  height: 70px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .card{
    width: 12.5%;
    min-width: 165px;
    height: 64px;
    margin-right: 10px;
    padding: 10px 15px;
    background: #F8F8F8;
    border-radius: 4px;
    >div:nth-child(1){
      display: flex;
      justify-content: space-between;
      >span:nth-child(1){
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }
      .que{
        display: block;
        width: 14px;
        height: 14px;
        border:1px solid #C7C7C7;
        border-radius: 50%;
        text-align: center;
        line-height: 14px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        cursor: pointer;
      }
    }
    >div:nth-child(2){
      margin-top: 10px;
      >span:nth-child(1){
        margin-right: 4px;
        font-size: 20px;
        font-family: RobotoCondensed-Bold, RobotoCondensed;
        font-weight: bold;
        color: #333333;
      }
      >span:nth-child(2){
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }
    }
  }
}
.target_sele{
  width: 100%;
  height: 50px;
  margin-top: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  >span{
    margin-right: 10px;
  }
}
</style>